'use strict';

export default class LoginController {
  user = {
    name: '',
    email: '',
    password: ''
  };
  /*errors = {
    login: undefined
  };*/
  submitted = false;


  /*@ngInject*/
  constructor(Auth, $state, $http, $scope) {
    this.Auth = Auth;
    this.$state = $state;
    this.$http = $http;
    var vm = this;

    vm.send = function() {
      vm.clicked = true;
      $http.post('api/users/forgot-password', {email : vm.email}).then(function (argument) {
        vm.sent = true;
      })
    }
  }

  login(form) {
    this.submitted = true;

    if(form.$valid) {
      this.errors = undefined
      this.Auth.login({
        email: this.user.email,
        password: this.user.password
      })
        .then(() => {
          // Logged in, redirect to home
          this.$state.go('sites');
        })
        .catch(err => {
          this.errors = {
            login : err.message
          };
        });
    }
  }
  
  forgotPassword() {
    $('#forgotPassword').modal('show');
  }

  dismiss() {
    $('#forgotPassword').modal('hide');
    this.email = '';
    this.sent = false;
  }
}



// WEBPACK FOOTER //
// ./client/app/account/login/login.controller.js